import { useEffect } from 'react'
import { useOptionalCommands } from '../../commands/CommandContext.js'

// Restore the existing layout without changing its saved panes or active chart.
export function useChartRestoreCommand({ ready, onRestore }) {
  const commands = useOptionalCommands()
  useEffect(() => {
    if (!commands) return undefined
    return commands.registerCommandHandler('position.chart.restore', () => {
      if (!ready) return { ok: false, reason: 'layout_loading' }
      onRestore()
      return { ok: true }
    })
  }, [commands, ready, onRestore])
}
